"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterableListActions = void 0;
const actions_1 = require("../actions");
class FilterableListActions {
}
exports.FilterableListActions = FilterableListActions;
FilterableListActions.CHANGE = 'FILTER_CHANGE';
FilterableListActions.RESET = 'FILTER_RESET';
FilterableListActions.RESET_TAB_FILTERS = 'FILTER_TAB_RESET';
FilterableListActions.CANCEL = 'FILTER_CANCEL';
FilterableListActions.QUERY_CHANGE = 'FILTER_QUERY_CHANGE';
FilterableListActions.SORT_CHANGE = 'FILTER_SORT_CHANGE';
FilterableListActions.PAGE_CHANGE = 'FILTER_PAGE_CHANGE';
FilterableListActions.PAGE_SIZE_CHANGE = 'FILTER_PAGE_SIZE_CHANGE';
FilterableListActions.change = (groupValue, filterValue, unSelect = false, isSub = false) => {
    return (0, actions_1.createAction)(FilterableListActions.CHANGE, {
        filterValue,
        groupValue,
        unSelect,
        isSub,
    });
};
FilterableListActions.reset = () => {
    return (0, actions_1.createAction)(FilterableListActions.RESET, undefined);
};
FilterableListActions.resetTabFilters = () => {
    return (0, actions_1.createAction)(FilterableListActions.RESET_TAB_FILTERS, undefined);
};
FilterableListActions.cancel = (previousSelectedFilters) => {
    return (0, actions_1.createAction)(FilterableListActions.CANCEL, previousSelectedFilters);
};
FilterableListActions.pageChange = (pageNumber, filterChanged = false) => {
    return (0, actions_1.createAction)(FilterableListActions.PAGE_CHANGE, {
        pageNumber,
        filterChanged,
    });
};
FilterableListActions.pageSizeChange = (pageSize, filterChanged = false) => {
    return (0, actions_1.createAction)(FilterableListActions.PAGE_SIZE_CHANGE, {
        pageSize,
        filterChanged,
    });
};
FilterableListActions.sortChange = (sortBy) => {
    return (0, actions_1.createAction)(FilterableListActions.SORT_CHANGE, sortBy);
};
FilterableListActions.queryChange = (query, isInitialSearch) => {
    return (0, actions_1.createAction)(FilterableListActions.QUERY_CHANGE, {
        query,
        isInitialSearch,
    });
};
